import moment from 'moment'
import React from 'react'
import { sortColumnLabel } from '../../actions/tx_grid_sort'
import { RANGE_CLAMPED, RANGE_DEFAULT, SORT_WINDOW_DEFAULT_DAYS } from '../../utils/sort_window'

const DISPLAY_FORMAT = 'MMM D, YYYY'

const formatDay = (day) => moment.utc(day).format(DISPLAY_FORMAT)

const SortWindowNote = ({ adjustment, sortField, range, hint }) => {
  if (adjustment === RANGE_CLAMPED) {
    return (
      <small className='text-muted'>
        {`Sorting is limited to 1 year — showing ${formatDay(range.startDate)} – ${formatDay(range.endDate)} (UTC).`}
      </small>
    )
  }
  if (adjustment === RANGE_DEFAULT) {
    return (
      <small className='text-muted'>
        {`Sorting by ${sortColumnLabel(sortField)} shows the last ${SORT_WINDOW_DEFAULT_DAYS} days.`}
        {hint && ` ${hint}`}
      </small>
    )
  }
  return null
}

export default SortWindowNote
